// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-small {\n  font-size: 0.8rem;\n}\n.doctor-list {\n  max-height: 300px;\n  overflow: auto;\n}\n", ""]);
// Exports
module.exports = exports;
